<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div aria-describedby="modalDescription"
           aria-labelledby="modalTitle"
           class="modal modal-custom-text"
           role="dialog"
      >
        <header
            id="modalTitle"
            class="modal-header"
        >
          <slot name="header">
            Êtes-vous sûr(e) ?!
          </slot>
        </header>

        <section
            id="modalDescription"
            class="modal-body"
        >
          <slot name="body">
            Vous êtes sur le point de quitter le test.<br><br>
            Il vous sera possible de vous reconnecter dans le temps imparti, mais passé ce délai, vous n'aurez plus accès au test.<br>
            <br>
            Souhaitez-vous quitter ?
          </slot>
        </section>

        <footer class="modal-footer">

          <button
              aria-label="Close modal"
              class="btn"
              type="button"
              @click="finish"
          >
            Oui
          </button>
          <button
              aria-label="Close modal"
              class="btn"
              type="button"
              @click="close"
          >
            Non
          </button>

        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import UserService from "@/services/user.service";

export default {
  name: 'Modal',
  methods: {
    close() {
      this.$emit('close');
    },
    finish() {
      UserService.saveQuestionnaireToEva().then(
          (response) => {
            this.$router.push({name: 'mes-tests'});
          },
          (error) => {
            this.loading = false;
            alert(error.response.data.detail)
          }
      );
    },
  },
};
</script>